import { TaskCenterTypesV2 } from '@frontend/api-task-center';
import { SelectedFilters } from '@frontend/task-center-scope';

interface PrepareFiltersParams {
  locationIds: string[];
  selectedFilters: SelectedFilters;
  assigneeFilter?: string;
  statuses?: TaskCenterTypesV2.SchemaTypes.Enums.TaskStatus[];
  patientId?: string;
  isAIRCreatorEnabled: boolean;
}

export const prepareTaskFilters = ({
  locationIds,
  selectedFilters,
  assigneeFilter,
  statuses,
  patientId,
  isAIRCreatorEnabled,
}: PrepareFiltersParams): TaskCenterTypesV2.SchemaTypes.ListTasksRequestV2['filters'] => {
  const filters: TaskCenterTypesV2.SchemaTypes.ListTasksRequestV2['filters'] = {
    locationId: locationIds,
    status: statuses?.length ? statuses : undefined,
    patientId: patientId ? [patientId] : undefined,
  };

  if (selectedFilters.source) {
    filters['source'] = selectedFilters.source;
  }

  if (isAIRCreatorEnabled && selectedFilters.creator) {
    filters['creatorFilter'] = selectedFilters.creator;
  } else if (!isAIRCreatorEnabled && selectedFilters.creator && 'userId' in selectedFilters.creator) {
    filters['createdBy'] = selectedFilters.creator['userId'];
  }

  if (assigneeFilter) {
    filters['assignee'] = [assigneeFilter];
  }

  return filters;
};

export const preparePagination = (
  selectedFilters: SelectedFilters
): TaskCenterTypesV2.SchemaTypes.ListTasksRequestV2['pagination'] => {
  const pagination: TaskCenterTypesV2.SchemaTypes.ListTasksRequestV2['pagination'] = {};

  if (selectedFilters.sortType) {
    pagination['sortField'] = selectedFilters.sortType;
    pagination['sortType'] = TaskCenterTypesV2.SchemaTypes.Enums.SortType.SORT_ASC;
  }

  return pagination;
};
